import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-[var(--red2)] px-4 py-2 flex items-center justify-center gap-3" data-id="element-303">
      <span className="w-2 h-2 rounded-full bg-red-300 animate-pulse-dot flex-shrink-0" data-id="element-304" />
      <span className="text-[13px] font-semibold tracking-wider uppercase" data-id="element-305">
        La oferta termina en
      </span>
      <div className="flex gap-1 items-center" data-id="element-306">
        <div className="bg-black/30 rounded-md px-2.5 py-0.5 text-center min-w-[38px]" data-id="element-307">
          <span className="text-lg font-bold tracking-wide block" data-id="element-308">
            {pad(minutes)}
          </span>
        </div>
        <span className="text-lg font-bold opacity-60" data-id="element-309">:</span>
        <div className="bg-black/30 rounded-md px-2.5 py-0.5 text-center min-w-[38px]" data-id="element-310">
          <span className="text-lg font-bold tracking-wide block" data-id="element-311">
            {pad(seconds)}
          </span>
        </div>
      </div>
    </div>;
}